import type { ReactNode } from "react";

import { useIsLoggedIn } from "@jti/app-context/PageAuthContext";
import { useSelector } from "@jti/store/reduxHooks";
import { PushBlock, type PushBlockProps } from "@jti/ui/components/PushBlock";
import { useUser } from "@jti/ui/hooks/useUser";

export type LoyaltyPushBlockProps = PushBlockProps &
  Partial<{
    ctaLogged: string;
    hrefLogged: string;
    ctaRestricted: string;
    hrefRestricted: string;
    renderMedia: ReactNode;
  }>;

export const LoyaltyPushBlock = (props: LoyaltyPushBlockProps) => {
  const { isUserLoggedIn } = useUser();
  // `useUser` starts `false` and resolves from localStorage on the client, so OR-ing in the
  // route-seeded hint keeps the logged-in variant correct at first paint.
  const isRouteLoggedIn = useIsLoggedIn();
  const isLoggedIn = isUserLoggedIn || isRouteLoggedIn;

  const { isRestricted } = useSelector((store) => store.loyaltyCore);

  const { cta, ctaLogged, href, hrefLogged, ctaRestricted, hrefRestricted, renderMedia, ...restProps } = props;
  let buttonText = cta;
  let buttonUrl = href;

  if (ctaLogged && hrefLogged && isLoggedIn) {
    if (ctaRestricted && hrefRestricted && isRestricted) {
      buttonText = ctaRestricted;
      buttonUrl = hrefRestricted;
    } else {
      buttonText = ctaLogged;
      buttonUrl = hrefLogged;
    }
  }

  const renderImageOverride = renderMedia ? () => <>{renderMedia}</> : undefined;

  return (
    <PushBlock
      {...restProps}
      cta={buttonText}
      href={buttonUrl}
      className="light-theme"
      {...(renderImageOverride && { renderImage: renderImageOverride })}
    />
  );
};
